// src/lib/auth-client.ts

import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";
// Better Auth ≥1.5: the apiKey client plugin moved to its own package.
import { apiKeyClient } from "@better-auth/api-key/client";

const APP_URL = process.env.NEXT_PUBLIC_APP_URL;
// Preview deployments don't have NEXT_PUBLIC_APP_URL set to their own URL
// (it's scoped per-environment in Vercel) — fall back to the deployment's
// actual URL instead of hardcoded production, or login silently targets prod.
const VERCEL_PREVIEW_URL = process.env.NEXT_PUBLIC_VERCEL_URL;
const RESOLVED_APP_URL = APP_URL
  ? APP_URL.replace(/\/$/, "")
  : VERCEL_PREVIEW_URL
    ? `https://${VERCEL_PREVIEW_URL}`
    : undefined;

/* ──────────────────────────────── TYPES ──────────────────────────────────── */
declare module "better-auth/react" {
  interface AuthClient {
    signIn: {
      email: (data: {
        email: string;
        password: string;
      }) => Promise<{
        data: any;
        error: { message: string; status: number } | null;
      }>;
    };
    requestPasswordReset: (data: {
      email: string;
      redirectTo?: string;
    }) => Promise<{
      data: any;
      error: { message: string; status: number } | null;
    }>;
    resetPassword: (data: {
      newPassword: string;
      token: string;
    }) => Promise<{
      data: any;
      error: { message: string; status: number } | null;
    }>;
  }
}

/* ─────────────────────────── CLIENT INSTANCE ───────────────────────────── */
export const authClient = createAuthClient({
  // Use relative URL in dev so cookies are sent; if you have NEXT_PUBLIC_APP_URL, it'll prepend it
  baseURL: RESOLVED_APP_URL
    ? `${RESOLVED_APP_URL}/api/auth`
    : "https://www.niftipay.com/api/auth",
  plugins: [
    apiKeyClient(),
    twoFactorClient(),
  ],
  fetchOptions: { credentials: "include" },
});
